import * as actionTypes from '../types/task';

const initialState = {
  taskList: [],
  semiByTaskList: [],
  zdvlForAddList: [],
  taskGet: {
    okRequest: false,
    loading: false
  },
  semiByTaskGet: {
    okRequest: false,
    loading: false
  },
  taskSave: {
    okRequest: false,
    loading: false
  },
  taskZdvlLineAdd: {
    okRequest: false,
    loading: false
  },
  taskSemiAdd: {
    okRequest: false,
    loading: false
  },
  taskSemiDelete: {
    okRequest: false,
    loading: false
  },
  taskZdvlLineDelete: {
    okRequest: false,
    loading: false
  },
  taskZdvlForAddGet: {
    okRequest: false,
    loading: false
  },
  taskDelete: {
    okRequest: false,
    loading: false
  },
  taskUpdate: {
    okRequest: false,
    loading: false
  },
  okUpdate: false,
  taskOpenClose: {
    okRequest: false,
    loading: false
  },
  okOpenClose: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_TASK_LIST:
      return {
        ...state,
        taskGet: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.GET_TASK_LIST_SUCCESS:
      return {
        ...state,
        taskList: payload,
        taskGet: {
          okRequest: true,
          loading: false
        },
        okUpdate: false
      };

    case actionTypes.GET_TASK_LIST_FAIL:
      return {
        ...state,
        taskGet: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.GET_SEMI_LIST_BY_TASK:
      return {
        ...state,
        semiByTaskGet: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.GET_SEMI_LIST_BY_TASK_SUCCESS:
      return {
        ...state,
        semiByTaskList: payload,
        semiByTaskGet: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.GET_SEMI_LIST_BY_TASK_FAIL:
      return {
        ...state,
        semiByTaskGet: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.SAVE_TASK:
      return {
        ...state,
        taskSave: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.SAVE_TASK_SUCCESS:
      return {
        ...state,
        taskSave: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.SAVE_TASK_FAIL:
      return {
        ...state,
        taskSave: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.ADD_TASK_ZDVL_LINE:
      return {
        ...state,
        taskZdvlLineAdd: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.ADD_TASK_ZDVL_LINE_SUCCESS:
      return {
        ...state,
        taskZdvlLineAdd: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.ADD_TASK_ZDVL_LINE_FAIL:
      return {
        ...state,
        taskZdvlLineAdd: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.ADD_TASK_SEMI:
      return {
        ...state,
        taskSemiAdd: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.ADD_TASK_SEMI_SUCCESS:
      return {
        ...state,
        taskSemiAdd: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.ADD_TASK_SEMI_FAIL:
      return {
        ...state,
        taskSemiAdd: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.DELETE_TASK_SEMI:
      return {
        ...state,
        taskSemiDelete: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.DELETE_TASK_SEMI_SUCCESS:
      return {
        ...state,
        taskSemiDelete: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.DELETE_TASK_SEMI_FAIL:
      return {
        ...state,
        taskSemiDelete: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.DELETE_TASK_ZDVL_LINE:
      return {
        ...state,
        taskZdvlLineDelete: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.DELETE_TASK_ZDVL_LINE_SUCCESS:
      return {
        ...state,
        taskZdvlLineDelete: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.DELETE_TASK_ZDVL_LINE_FAIL:
      return {
        ...state,
        taskZdvlLineDelete: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.GET_ZDVL_LIST_FOR_ADD:
      return {
        ...state,
        taskZdvlForAddGet: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.GET_ZDVL_LIST_FOR_ADD_SUCCESS:
      return {
        ...state,
        zdvlForAddList: payload,
        taskZdvlForAddGet: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.GET_ZDVL_LIST_FOR_ADD_FAIL:
      return {
        ...state,
        taskZdvlForAddGet: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.DELETE_TASK:
      return {
        ...state,
        taskDelete: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.DELETE_TASK_SUCCESS:
      return {
        ...state,
        taskDelete: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.DELETE_TASK_FAIL:
      return {
        ...state,
        taskDelete: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.UPDATE_TASK:
      return {
        ...state,
        taskUpdate: {
          okRequest: false,
          loading: true
        }
      };
    case actionTypes.UPDATE_TASK_SUCCESS:
      return {
        ...state,
        taskUpdate: {
          okRequest: true,
          loading: false
        },
        okUpdate: true
      };
    case actionTypes.UPDATE_TASK_CLEAR:
    case actionTypes.UPDATE_TASK_FAIL:
      return {
        ...state,
        taskUpdate: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.SET_OPEN_CLOSE_TASK:
      return {
        ...state,
        taskOpenClose: {
          okRequest: false,
          loading: true
        }
      };
    case actionTypes.SET_OPEN_CLOSE_TASK_SUCCESS:
      return {
        ...state,
        taskOpenClose: {
          okRequest: true,
          loading: false
        },
        okOpenClose: true
      };
    case actionTypes.SET_OPEN_CLOSE_TASK_FAIL:
      return {
        ...state,
        taskOpenClose: {
          okRequest: false,
          loading: false
        }
      };
    case actionTypes.SET_INITIAL_STATE_TASK:
      return {
        ...state,
        taskZdvlLineAdd: {
          okRequest: false,
          loading: false
        },
        taskSemiAdd: {
          okRequest: false,
          loading: false
        },
        taskDelete: {
          okRequest: false,
          loading: false
        }
      };
    default:
      return state;
  }
};

export default reducer;
